import { FC } from 'react';
import { Box, Flex, FlexProps, Image, Text, theme } from '@chakra-ui/react';
export interface CbChestsPrizeBadgeProps extends FlexProps {
  badgeName: string;
  badgeUrl: string;
}
export const CbChestsPrizeBadge: FC<CbChestsPrizeBadgeProps> = ({
  badgeName,
  badgeUrl,
  ...props
}) => {
  return <Flex alignItems="center" {...props} data-sentry-element="Flex" data-sentry-component="CbChestsPrizeBadge" data-sentry-source-file="CbChestsPrizeBadge.tsx">
      <Box marginRight={[3, 4]} width={['44px', '70px']} data-sentry-element="Box" data-sentry-source-file="CbChestsPrizeBadge.tsx">
        <Image src={badgeUrl} alt="Badge" position="relative" zIndex={theme.zIndices.docked} data-sentry-element="Image" data-sentry-source-file="CbChestsPrizeBadge.tsx" />
      </Box>
      <Text position="relative" whiteSpace="nowrap" data-sentry-element="Text" data-sentry-source-file="CbChestsPrizeBadge.tsx">
        {`${badgeName} Badge!`}
      </Text>
    </Flex>;
};